module.exports = __webpack_public_path__ + "img/copy.77fd2130.png";